module.exports = __webpack_public_path__ + "static/granular-thumbnail-3a923c26327d8cdfaeef4fa9e92e76e5.png";